<template>
    <div class="page-body">
      <div class="container-fluid">
        <div class="edit-profile">
          <div class="row">
            <div class="col-12 col-xl-12">
              <div class="card">
                <div class="card-header">
                  <div class="text-neutral-500 text-xl font-medium font-['Poppins'] leading-normal">
                    {{ DoucmentId && DoucmentId !== '' ? "Editar Documento" : "Crear Documento" }}
                  </div>
                </div>
                <div class="card-body mobile-padding" style="margin-top: 20px;">
                  <form @submit.prevent="submitForm">
                    <div class="flex flex-col md:flex-row md:gap-8 gap-4">
                      <!-- Nombre del documento -->
                      <div class="flex flex-col gap-4 w-full md:w-[300px]">
                        <div class="w-[300px] h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                          <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Nombre del documento</label>
                          <input 
                            type="text" 
                            v-model="form.name_doc"
                            @input="validateField('name_doc')"
                            class="self-stretch px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal" 
                            placeholder="Nombre del docuemento"  
                          />
                          <!-- Alerta para nombre -->
                          <div v-if="showNameAlert" class="required-alert">
                            <div class="yellow-box">!</div>
                              <span>Completa el nombre del documento</span>
                          </div>
                        </div>
                        <!-- Tipo de documento -->
                        <div class="w-full w-[300px] h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                          <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Tipo de documento</label>
                          <input 
                            type="text" 
                            v-model="form.type_doc"
                            @input="validateField('type_doc')"
                            class="self-stretch px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"
                            placeholder="Tipo del documento" 
                          />
                          <!-- Alerta para tipo -->
                          <div v-if="showTypeAlert" class="required-alert">
                            <div class="yellow-box">!</div>
                            <span>Completa el tipo de documento</span>
                          </div>
                        </div>
                      </div>
                    <!-- Columna 2: Estatus y Versión -->
                    <div class="flex flex-col md:flex-row gap-4 w-full md:w-auto">
                      <!-- Estatus -->
                      <div class="w-full md:w-[300px] h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                        <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">
                          Estatus
                        </label>
                        <select 
                          v-model="form.status"
                          @input="validateField('status')"
                          class="self-stretch px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"
                          
                        >
                          <option value="">Selecciona</option>
                          <option value="Desactivado">Desactivado</option>
                          <option value="Publicado">Publicado</option>
                          <option value="Borrador">Borrador</option>
                        </select>
                        <!-- Alerta para estatus -->
                        <div v-if="showStatusAlert" class="required-alert">
                          <div class="yellow-box">!</div>
                          <span>Selecciona un estatus</span>
                        </div>
                      </div>
                      <!-- Versión -->
                      <div class="w-full md:w-[300px] h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                        <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Versión</label>
                        <input 
                          type="text" 
                          v-model="form.version"
                          @input="validateField('version')"
                          class="self-stretch px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"
                          placeholder="Versión del documento" 
                        />
                        <!-- Alerta para versión -->
                        <div v-if="showVersionAlert" class="required-alert">
                          <div class="yellow-box">!</div>
                          <span>Completa la versión del documento</span>
                        </div>
                      </div>                  
                    </div>
                    </div>
                    <!-- Contenico -->
                    <div class="w-full flex flex-col gap-2 mt-4">
                      <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">
                          Contenido
                      </label>
                      <div class="w-full text-white p-2 rounded-md">
                      <ckeditor
                          v-model="form.content"
                          @input="validateField('content')"
                          :editor="editor"
                          :config="editorConfig"
                          class="w-full h-40"
                      ></ckeditor>
                    </div>
                      <!-- Alerta para contenido -->
                       <div v-if="showContentAlert" class="required-alert">
                        <div class="yellow-box">!</div>
                        <span>Añade contenido al documento</span>
                      </div>
                    </div>
                    <!-- Botón -->
                    <div class="form-footer flex sm:flex-row justify-end gap-2 sm:gap-4 mt-4">
                      <button type="button" class="custom-cancel-btn w-full sm:w-auto" @click="cancelChanges">
                        <span class="custom-cancel-btn-text">Cancelar</span>
                      </button>
                      <button type="submit" class="custom-create-btn w-full sm:w-auto" :disabled="isSubmitting"
                      :class="{ 'disabled-button': isSubmitting }">
                        <span class="custom-create-btn-text">{{ isSubmitting ? 'Guardando...' : 'Guardar' }}</span>
                      </button>
                    </div>
                  </form>
                </div>
                <!-- Mensaje de éxito -->
                <div v-if="successMessage" class="user-alert">
                  <div class="user-alert-content">
                    <div class="user-alert-text">
                      {{ successMessage }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
  
<script>
  import axios from "axios";
  import { ref, computed, onMounted } from "vue";
  import { useStore } from "vuex";
  import { useRouter } from "vue-router";
  import { useRoute } from "vue-router";
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

  export default {
    setup() {
      const store = useStore();
      const session = computed(() => store.getters.getUserSession);
      const route = useRoute();
      const DoucmentId = computed(() => route.params.id);  // Obtener el ID del rol desde la URL
      const editor            = ref(ClassicEditor);
      const showNameAlert = ref(false);
      const showTypeAlert = ref(false);
      const showStatusAlert = ref(false);
      const showVersionAlert = ref(false);
      const showContentAlert = ref(false);
      const isSubmitted = ref(false);
      const isSubmitting = ref(false); // Bloqueo de boton guardar 
      const editorConfig = {
      toolbar: [
          "heading",
          "|",
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "|",
          "link",
          "blockQuote",
          "|",
          "undo",
          "redo",
          "|",
          "numberedList",
          "bulletedList",
          "|",
          "alignment",
          "indent",
          "outdent",
          "|",

          "insertHR",
          "code",
          "codeBlock",
          "removeFormat",
      ],
      height: "500px",
      };

      const form = ref({
        name_doc: "",
        type_doc: "",
        status: "",
        version: "",
        content: ""
      });
      const successMessage = ref("");
      const router = useRouter();
  
      // Función para validar campos
      const validateField = (field) => {
        let isValid = true;
      switch(field) {
        case 'name_doc':
          showNameAlert.value = form.value.name_doc.trim() === '';
          isValid = !showNameAlert.value;
          break;
        case 'type_doc':
          showTypeAlert.value = form.value.type_doc.trim() === '';
          isValid = !showTypeAlert.value;
          break;
        case 'status':
          showStatusAlert.value = form.value.status.trim() === '';
          isValid = !showStatusAlert.value;
          break;
        case 'version':
          showVersionAlert.value = form.value.version.trim() === '';
          isValid = !showVersionAlert.value;
          break;
        case 'content':
          showContentAlert.value = form.value.content.trim() === '';
          isValid = !showContentAlert.value;
          break;
      }
      return isValid;
    };

      // Función para cargar los datos del rol cuando estamos en modo de edición
      const loadRoleData = async () => {
        if (DoucmentId.value) {
          try {
            const token = session.value.token_api;
            if (!token) {
              console.error("No se ha encontrado el token de autenticación.");
              return;
            }
  
            const options = {
              headers: {
                Authorization: `Bearer ${token}`
              }
            };

            // Hacer la solicitud GET para obtener los datos del rol
            const response = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/legal-form/${DoucmentId.value}`, options);
            if (response.status === 200) {
              // Asignar los datos al formulario
              form.value.name_doc = response.data.data.name_doc;
              form.value.type_doc = response.data.data.type_doc;
              form.value.status = response.data.data.status;
              form.value.version = response.data.data.version;
              form.value.content = response.data.data.content;
            }
          } catch (error) {
            console.error("Error al cargar los datos del documento:", error);
          }
        }
      };
  
      // Llamar a la función cuando el componente se monta
      onMounted(() => {
        console.log("DoucmentId:", DoucmentId.value); // Muestra el valor de DoucmentId
        loadRoleData();
      });
  
      // Limpiar todas las alertas
      const submitForm = async () => {
      showNameAlert.value = false;
      showTypeAlert.value = false;
      showStatusAlert.value = false;
      showVersionAlert.value = false;
      showContentAlert.value = false;

      // Validar campos en orden de importancia
      if (!validateField('name_doc')) return;
      if (!validateField('type_doc')) return;
      if (!validateField('status')) return;
      if (!validateField('version')) return;
      if (!validateField('content')) return;

      if (isSubmitting.value || !allFieldsFilled.value) return;
  
      isSubmitting.value = true;
        try {
          const token = session.value.token_api;
          if (!token) {
            console.error("No se ha encontrado el token de autenticación.");
            return;
          }
  
          const options = {
            headers: {
              Authorization: `Bearer ${token}`
            }
          };
  
          const endpoint = DoucmentId.value
            ? `${process.env.VUE_APP_API_BASE_URL}/legal-form/${DoucmentId.value}`
            : `${process.env.VUE_APP_API_BASE_URL}/legal-form`;
            
          const method = DoucmentId.value ? "post" : "post";
          const dataToSend = { ...form.value };
          delete dataToSend.id; // Eliminar el ID del cuerpo
  
          // Hacer la solicitud para guardar el rol
          const response = await axios[method](endpoint, dataToSend, options);
  
          if (response.status === 200 || response.status === 201) {
            successMessage.value = "Docuemnto guardado con éxito.";
  
            // Limpiar el formulario si es un nuevo rol
            if (!DoucmentId.value) {
              form.value.name = "";
              form.value.description = "";
            }
  
            setTimeout(() => {
              successMessage.value = "";
              router.push({ name: "legal_list" });
            }, 2000);
          }
        } catch (error) {
          console.error("Error al guardar el documento:", error);
          isSubmitting.value = false;
          if (error.response) {
            console.error("Error de servidor:", error.response.data);
          }
        }
      };
      // Función computada para verificar si todos los campos están llenos
      const allFieldsFilled = computed(() => {
        return (
          form.value.name_doc.trim() !== '' &&
          form.value.type_doc.trim() !== '' &&
          form.value.status.trim() !== '' &&
          form.value.version.trim() !== '' &&
          form.value.content.trim() !== ''
        );
      });

      const cancelChanges = () => {
      router.push({ name: "legal_list" });
      };

      return {
        DoucmentId,
        form,
        submitForm,
        editorConfig,
        editor,
        successMessage,
        showNameAlert,
        showTypeAlert,
        showStatusAlert,
        showVersionAlert,
        showContentAlert,
        isSubmitted,
        cancelChanges,
        validateField
      };
    }
  };
</script>
<style>
  .ck-editor__editable_inline {
    background-color: rgb(253, 253, 253) !important;
    color: rgb(9, 9, 9) !important;
  }

  .disabled-button {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .required-alert {
    display: flex;
    align-items: center;
    background-color: #fff;
    color: #333;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin-top: 5px;
    position: relative;
    max-width: 300px;
    word-wrap: break-word;
  }

  .required-alert .yellow-box {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    background-color: #e59035;
    margin-right: 10px;
    border: 1px solid #e59035;
    border-radius: 4px;
    color: #fff;
    font-weight: bold;
    font-size: 16px;
    line-height: 1;
  }

  .required-alert::after {
    content: "";
    position: absolute;
    top: -10px;
    left: 20px;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #fff;
    z-index: 1;
  }

  .required-alert::before {
    content: "";
    position: absolute;
    top: -11px;
    left: 19px;
    width: 0;
    height: 0;
    border-left: 11px solid transparent;
    border-right: 11px solid transparent;
    border-bottom: 11px solid #ccc;
    z-index: 0;
  }

  .custom-cancel-btn {
  display: inline-flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  background: #4B5563; /* Gris oscuro */
  border: 1px solid #4B5563;
  color: white;
  cursor: pointer;
  margin-right: 10px; /* Espacio entre botones */
  transition: all 0.3s ease;
}

.custom-cancel-btn-text {
  color: #FFF;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

.custom-create-btn {
  display: inline-flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  background: #ff4265;
  border: 1px solid #ff4265;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
}

.custom-create-btn-text {
  color: #FFF;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  width: 100%;
}

.form-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.mobile-padding {
  padding: 15px;
}

/* Estilos responsivos */
@media (max-width: 767px) {
  .card-body {
    padding: 15px;
  }
  
  .flex-col-mobile {
    flex-direction: column;
  }
  
  .w-full-mobile {
    width: 100% !important;
  }
  
  .gap-8 {
    gap: 1rem;
  }
  
  .form-footer {
    flex-direction: column;
    gap: 10px;
  }
  
  .custom-cancel-btn, 
  .custom-create-btn {
    width: 100%;
    margin-right: 0;
    margin-bottom: 10px;
  }
  
  .ck-editor__editable_inline {
    min-height: 200px;
  }
}

@media (min-width: 768px) {
  .form-footer {
    justify-content: flex-end;
    gap: 10px;
  }
  
  .mobile-padding {
    padding: 20px;
  }
}
</style>